<template>
  <modal
    v-if="asset"
    name="edit-content-source-modal"
    height="auto"
    :scrollable="false"
    class="vue-modal"
    width="45%"
  >
    <div class="vue-modal-inner">
      <div class="vue-modal-topbar">
        <h4>Content Source ID {{ asset.id }}</h4>
      </div>
      <div class="modal-container">
        <div class="content-source-container">
          <div class="content-source-section">
            <label for="content-source-name">Name</label>
            <input
              v-model="asset.name"
              name="name"
              type="text"
              class="hlt-input"
            >
            <error-message
              v-if="errors"
              :message="prettyErrors"
            />
          </div>
          <div class="content-source-row">
            <div class="content-source-section row-item">
              <label
                for="content-source-type"
                class="content-source-label"
              >Featured Attachment ID</label>
              <input
                v-model="asset.featured_attachment_id"
                name="featured_attachment_id"
                type="text"
                class="hlt-input"
              >
            </div>
            <div class="content-source-section">
              <label
                for="content-source-type"
                class="content-source-label"
              >Preview Attachment ID</label>
              <input
                v-model="asset.preview_attachment_id"
                name="preview_attachment_id"
                type="text"
                class="hlt-input"
              >
            </div>
          </div>
          <div class="content-source-row">
            <div class="content-source-section">
              <label for="content-source-name">Description</label>
              <tinymce-editor
                ref="title-editor"
                v-model="asset.description_html"
                :init="tinymceConfig({plugins: ['code', 'autoresize', 'lists'], forced_root_block : ''}, tinymceSmallConfig)"
                name="title"
                @onInit="setCaretPosition"
              />

            </div>
          </div>
          <div class="content-source-row">
            <div class="content-source-section toggle-section">
              <hlt-toggle
                style-type="medium"
                :value="asset.visibility"
                :labels="{
                  checked: 'Visible', unchecked: 'Not Visible'
                }"
                sync
                @change="toggleVisibility"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vue-modal-bottombar modal-buttons">
      <button
        class="hlt-button default modal-button"
        @click="cancel"
      >
        Cancel
      </button>
      <button
        class="hlt-button primary save-content-source-button"
        @click="save(asset)"
      >
        Save
      </button>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import railsRoutes from '../../../store/rails-routes.js'
import HltToggle from '../../../components/assets/shared/page_components/Toggle'
import TinymceEditor from '@tinymce/tinymce-vue'
import tinymce from '../../../mixins/tinymce.js'

export default {
  components: {
    HltToggle,
    TinymceEditor
  },
  mixins: [tinymce],
  data () {
    return {
      errors: null,
    }
  },
  computed: {
    ...mapGetters([
      'asset',
      'assetType',
      'currentUser',
    ]),
    prettyErrors () {
      if (this.errors.name) {
        if (this.errors.name.indexOf('can\'t be blank') >= 0) {
          return 'Name can\'t be blank'
        }
        if (this.errors.name.indexOf('has already been taken') >= 0) {
          return 'Name has already been taken'
        }
      }
      return 'Error'
    }
  },
  methods: {
    toggleVisibility () {
      this.asset.visibility = !this.asset.visibility
    },
    cancel () {
      this.$modal.hide('edit-content-source-modal')
    },
    save (asset) {
      this.update({ asset: this.asset, url: railsRoutes.api_path({ type: 'content_sources' }) }).then(() => {
        this.errors = null
        this.resetAsset()
        this.$notify({ title: 'Content Source Saved', type: 'success' })
        if (this.$modal) {
          this.$modal.hide('edit-content-source-modal')
        }
        this.resetSearchResults()
        this.searching()
      }).catch(error => {
        console.error(error)
        if (error && error.response) {
          this.errors = error.response.data
        }
        this.$notify({ title: 'Error Saving Content Source', type: 'error' })
      })
    },
    ...mapActions([
      'update',
      'searching'
    ]),
    ...mapMutations([
      'resetSearchResults',
      'resetAsset'
    ])
  }

}
</script>

<style lang="scss" scoped>
.modal-container {
  max-height: 500px;
  overflow: scroll;
}
.content-source-container {
  padding: 0 1rem;
  .content-source-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .content-source-section {
      flex: 1;
      &.row-item {
        justify-content: space-between;
        margin-right: 15px;
      }
      &.toggle-section {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
      }
    }
  }
}
.modal-buttons {
  padding: 15px 30px;
  display: flex;
  align-content: flex-end;
  align-items: flex-end;
  button {
    margin-left: 15px;
  }
}
</style>
